import { Route, Switch, useLocation } from 'react-router-dom';
import './App.css';
import '@stoplight/elements/styles.min.css';
import { lazy, useMemo } from 'react';
import { Box, Flex, Provider as MosaicProvider } from '@stoplight/mosaic';
import NotFound from './components/NotFound';
import { API_REGEX_STRING, API_URI, ARTICLE_REGEX_STRING, LOCAL_STORAGE_ID, PROJECT_ARTICLE_REGEX_STRING, HIDE_TRY_IT_BUTTON } from './constants';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';

const isOnIFrame = window.location !== window.parent.location;
const Home = lazy(() => import('./components/Home'));
const Api = lazy(() => import('./components/Api'));
function App() {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const hideParams = searchParams.get('hide');
  if (!isOnIFrame && hideParams) {
    localStorage.setItem(LOCAL_STORAGE_ID, hideParams);
  }

  return (
    <>
    <MosaicProvider>
      <Flex direction="col" bg="canvas" h="screen" className={HIDE_TRY_IT_BUTTON ? 'hideTryIt' : ''}>
          <Box flex={1} overflowY="hidden">
            <Switch>
              <Route exact path='/'>
                <Home/>
              </Route>
              <Route path={`/:article(${ARTICLE_REGEX_STRING})`}>
                <Home/>
              </Route>
              <Route exact path={`/:projectId`}>
                <Home/>
              </Route>
              <Route path={`/:projectId/:article(${PROJECT_ARTICLE_REGEX_STRING})`}>
                <Home/>
              </Route>
              <Route path={`/${API_URI}/:spec(${API_REGEX_STRING})`}>
                <Api/>
              </Route>
              <Route path={`/:projectId/:spec(${API_REGEX_STRING})`}>
                <Api/>
              </Route>
              <Route path='*'>
                <NotFound/>
              </Route>
            </Switch>
          </Box>
      </Flex>
    </MosaicProvider>
    </>
  );
}

export default App;
